class CreditCardCvvDialogController {
    constructor($document, $sce, $timeout, dialogRegistry, settings, digitalPayErrorMessageGenerator, digitalPayIframeEventHandler) {
        this.$document = $document;
        this.$sce = $sce;
        this.$timeout = $timeout;
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.digitalPayErrorMessageGenerator = digitalPayErrorMessageGenerator;
        this.digitalPayIframeEventHandler = digitalPayIframeEventHandler;
    }

    $onInit() {
        this.$timeout(() => {
            this.dialog = this.dialogRegistry.getDialog(this.dialogName);
        });

        this.iframeId = this.dialogName.split(' ').join('');
        this.isValidateDisabled = true;
        this.isLoading = true;
        this.hasIframeFailed = false;
        this.iframeLoadTimeoutPromise = undefined;
        this.setupListenerCallbacks();
    }

    $onDestroy() {
        this.disposeEventListeners();
    }

    setupListenerCallbacks() {
        this.payFrameLoadedCallback = () => {
            this.$timeout(() => {
                this.isLoading = false;

                // Cancel the timer and let the view know the iframe was successfully loaded
                this.$timeout.cancel(this.iframeLoadTimeoutPromise);
            });
        };

        this.payFrameErrorCallback = (response) => {
            this.isUpdating = false;
            if (!this.dialog.isOpen()) {
                return;
            }
            const errorMessage = this.digitalPayErrorMessageGenerator.getCreditCardDialogSubmitIframeError(response.code);
            if (response.code === this.settings.digitalPayErrorCodes.creditCardCaptureFormExpired) {
                this.$timeout(() => {
                    this.cvvErrorMessage = errorMessage;
                });
            } else {
                this.dialog.close({ success: false, errorMessage });
            }
        };

        this.payFrameSuccessCallback = (response) => {
            this.isUpdating = false;
            if (!this.dialog.isOpen() || !response.paymentInstrumentId || response.code !== '00') {
                return;
            }
            this.dialog.close({ success: true, stepUpToken: response.stepUpToken });
        };

        this.payFrameValidCallback = () => {
            this.$timeout(() => {
                this.isValidateDisabled = false;
                this.setInvalidCvvMessage();
            });
        };

        this.payFrameInvalidCallback = () => {
            this.$timeout(() => {
                this.isValidateDisabled = true;
            });
        };

        this.payFrameFocusLostCallback = () => {
            this.$timeout(() => {
                this.setInvalidCvvMessage();
            });
        };
    }

    registerEventListeners() {
        this.digitalPayIframeEventHandler.on('pay-frame-loaded', this.payFrameLoadedCallback, this.iframeId);
        this.digitalPayIframeEventHandler.on('pay-frame-error', this.payFrameErrorCallback, this.iframeId);
        this.digitalPayIframeEventHandler.on('pay-frame-success', this.payFrameSuccessCallback, this.iframeId);
        this.digitalPayIframeEventHandler.on('pay-frame-valid', this.payFrameValidCallback, this.iframeId);
        this.digitalPayIframeEventHandler.on('pay-frame-invalid', this.payFrameInvalidCallback, this.iframeId);
        this.digitalPayIframeEventHandler.on('pay-frame-focus-lost', this.payFrameFocusLostCallback, this.iframeId);
    }

    disposeEventListeners() {
        this.digitalPayIframeEventHandler.off('pay-frame-loaded', this.payFrameLoadedCallback);
        this.digitalPayIframeEventHandler.off('pay-frame-error', this.payFrameErrorCallback);
        this.digitalPayIframeEventHandler.off('pay-frame-success', this.payFrameSuccessCallback);
        this.digitalPayIframeEventHandler.off('pay-frame-valid', this.payFrameValidCallback);
        this.digitalPayIframeEventHandler.off('pay-frame-invalid', this.payFrameInvalidCallback);
        this.digitalPayIframeEventHandler.off('pay-frame-focus-lost', this.payFrameFocusLostCallback);
    }

    validateCvv() {
        this.cvvErrorMessage = '';
        this.isUpdating = true;
        this.digitalPayIframeEventHandler.emit(this.$document.find(`#${this.iframeId}`)[0], { eventId: 'pay-frame-submit' });
    }

    setupIframe() {
        this.hasIframeFailed = false;
        this.iframeUrl = this.$sce.trustAsResourceUrl(this.cvvUrl);
        this.iframeLoadTimeoutPromise = this.$timeout(() => {
            this.hasIframeFailed = true;
        }, this.settings.digitalPay.iframeTimeoutInMilliseconds);
    }

    setInvalidCvvMessage() {
        this.cvvErrorMessage = this.isValidateDisabled ? this.settings.digitalPayError.creditCardInvalidCvvMessage : '';
    }

    $onChanges(changes) {
        if (!changes.isIframeEnabled) {
            return;
        }

        // Enable or disable event listeners depending on the value of isIframeEnabled
        if (changes.isIframeEnabled.currentValue) {
            this.setupIframe();
            this.registerEventListeners();
            this.digitalPayIframeEventHandler.setIframeControl(this.iframeId);
        } else {
            this.disposeEventListeners();
            this.digitalPayIframeEventHandler.releaseIframeControl(this.iframeId);
        }
    }
}

CreditCardCvvDialogController.$inject = ['$document', '$sce', '$timeout', 'DialogRegistry', 'Settings', 'DigitalPayErrorMessageGenerator', 'DigitalPayIframeEventHandler'];

const creditCardCvvDialogComponentDefinition = {
    controller: CreditCardCvvDialogController,
    template: require('./credit-card-cvv-dialog.component.html').trim(),
    bindings: {
        dialog: '=',
        dialogName: '<',
        cvvUrl: '<',
        isIframeEnabled: '<',
        dialogCloseAction: '&',
    },
};

module.exports = {
    CreditCardCvvDialogController,
    creditCardCvvDialogComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/digitalpay/creditcard/credit-card-cvv-dialog.component.js